
export class LocalKeyData {

    protected static localKey: string = 'LocalKeyList';
    protected static localData = {};

    static addKey(key: string) {
        if (key == this.localKey) {
            return;
        }
        if (this.localData[key]) {
            return;
        }
        this.localData[key] = 1;
        this.saveLocalData();
    }

    static getData() {
        return this.localData;
    }

    // 存储数据
    static saveLocalData() {
        let key = this.getLocalDataKey();
        let saveData = JSON.stringify(this.localData);
        cc.sys.localStorage.setItem(key, saveData);
    }

    // 加载数据
    static loadLocalData() {
        let key = this.getLocalDataKey();
        let str: string | null = cc.sys.localStorage.getItem(key);
        if (!str) {
            return;
        }
        this.localData = JSON.parse(str);
        this.localData[this.localKey] = 1;
    }

    static resetData() {
        this.localData = {};
    }

    /**
     * 删除数据
     * @param key 
     */
    static deleteLocalData() {
        let key = this.getLocalDataKey();
        
    }

    static getLocalDataKey() {
        return this.localKey;
    }
}

